


























import { defineComponent } from '@nuxtjs/composition-api';
import MoominLink from '~/themes/fiskarsMoominDefault/components/components/atoms/MoominLink/MoominLink.vue';
import {PropType} from 'vue'
import {BenefitBarInterface} from 'types/index';

export default defineComponent({
  name: "MoominBenefitBar",
  components: { MoominLink },
  props: {
    benefits: {
      type: Array as PropType<BenefitBarInterface[]>,
      default: () => []
    }
  },
 });
